/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Result of preparing a WhatsApp Click-to-Chat link for an e-card entry. The frontend uses these fields to open `https://wa.me/{phoneNumber}?text={message}` and trusts the included trackingId so the recipient's later card view is recorded.
 * @export
 * @interface WhatsAppLinkResponse
 */
export interface WhatsAppLinkResponse {
    /**
     * recipient phone number from the configured WhatsApp field of the entry
     * @type {string}
     * @memberof WhatsAppLinkResponse
     */
    phoneNumber: string;
    /**
     * plain-text message body (HTML from the e-card mail template stripped via JSoup)
     * @type {string}
     * @memberof WhatsAppLinkResponse
     */
    message: string;
    /**
     * tracking id stored for this delivery — embedded in the card link inside the message
     * @type {string}
     * @memberof WhatsAppLinkResponse
     */
    trackingId: string;
}

/**
 * Check if a given object implements the WhatsAppLinkResponse interface.
 */
export function instanceOfWhatsAppLinkResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phoneNumber" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "trackingId" in value;

    return isInstance;
}

export function WhatsAppLinkResponseFromJSON(json: any): WhatsAppLinkResponse {
    return WhatsAppLinkResponseFromJSONTyped(json, false);
}

export function WhatsAppLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WhatsAppLinkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
        'message': json['message'],
        'trackingId': json['trackingId'],
    };
}

export function WhatsAppLinkResponseToJSON(value?: WhatsAppLinkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumber': value.phoneNumber,
        'message': value.message,
        'trackingId': value.trackingId,
    };
}

